// ═══════════════════════════════════════════════════════════════
// AGENCIAS · Explorador — ficha completa de una agencia
// (agency-profile.js). «Ver agencia» ya no es un modal: es una página que
// ocupa el sitio del Explorador (migas + «Volver al explorador de
// agencias»; al volver, la lista sigue como estaba; entra y sale con
// animación) con el color del plan
// (Titanium morado, Gold dorado, Silver azul):
//   · Tarjeta de presentación: banner de fondo (una imagen o, en Gold y
//     Titanium, un vídeo en bucle y sin sonido), logo, nombre, ubicación,
//     frase gancho, cifras, «Unirse a la agencia», «Contactar» y redes.
//   · Secciones, en el orden que elige la agencia (publicSectionOrder):
//       about      «Conoce <agencia>»: vídeo + texto (Titanium hasta 3 en
//                  carrusel, Gold 1, Silver solo texto); vídeos apaisados o
//                  verticales.
//       offers     «Qué ofrece esta agencia» (Gold y Titanium 6, Silver 3).
//       types      «Ideal para creadores de» (Titanium 6, Gold 4, Silver 2).
//       milestones «Hitos de la agencia» (hasta 3, con imagen opcional).
//   · «¿Te interesa unirte a <agencia>?», con el color del plan.
// Los iconos de «Qué ofrece» e «Ideal para creadores de» van en una gama
// de tonos del color del plan (PALETTES); la agencia elige el de cada uno.
// Lo de la tarjeta del directorio se pinta al instante; el resto, cuando
// llega GET /api/agency/profile. «Unirse a la agencia»: enlace de
// reclutamiento del Backstage o, si no hay, los pasos de whitelist.
// La ficha en sí (sheetHtml) y el cálculo del perfil desde un documento
// local (fromAgency) los reutiliza la vista previa de «Editar vista
// pública» de la consola (views/owner-console/public-view.js).
// Expone window.AgenciasAgencyProfile.
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

window.AgenciasAgencyProfile = (function () {
  'use strict';

  const S = () => window.AgenciasShared;
  const Card = () => window.AgenciasAgencyCard;
  const Dir = () => window.AgenciasDirectory;
  const t = (k, f) => S().t(k, f);
  const esc = v => Card().esc(v);
  const img = url => esc(S().safeImgUrl(url));

  const svg = (body, fill) => `<svg viewBox="0 0 24 24" ${fill ? 'fill="currentColor"' : 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"'}>${body}</svg>`;
  const I = {
    back: svg('<line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>'),
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    prev: svg('<polyline points="15 18 9 12 15 6"/>'),
    next: svg('<polyline points="9 18 15 12 9 6"/>'),
    play: svg('<path d="M8 5.5v13a1 1 0 0 0 1.5.9l11-6.5a1 1 0 0 0 0-1.8l-11-6.5A1 1 0 0 0 8 5.5z"/>', true),
    // Contacto
    mail: svg('<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/>'),
    globe: svg('<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>'),
    phone: svg('<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/>'),
    link: svg('<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/>'),
    tiktok: svg('<path d="M16.6 5.8A4.3 4.3 0 0 1 15.5 3h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.7a5.7 5.7 0 1 0 4.9 5.7V9a7.4 7.4 0 0 0 4.3 1.4V7.3a4.3 4.3 0 0 1-3.2-1.5z"/>', true),
    instagram: svg('<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.6" fill="currentColor"/>'),
    youtube: svg('<path d="M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12 31 31 0 0 0 1 16.8a3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8zM9.8 15V9l5.7 3z"/>', true),
    x: svg('<path d="M17.8 3h3.1l-6.8 7.7L22 21h-6.2l-4.9-6.3L5.3 21H2.2l7.3-8.3L2 3h6.3l4.4 5.8zm-1.1 16.2h1.7L7.4 4.7H5.6z"/>', true),
    discord: svg('<path d="M20.3 4.4A19.8 19.8 0 0 0 15.4 3l-.6 1.3a18.4 18.4 0 0 0-5.6 0L8.6 3a19.7 19.7 0 0 0-4.9 1.4C.6 9 0 13.6.3 18.1A19.9 19.9 0 0 0 6.3 21l1.3-2.1a12.9 12.9 0 0 1-2-1l.5-.4a14.2 14.2 0 0 0 11.8 0l.5.4c-.6.4-1.3.7-2 1l1.3 2.1a19.8 19.8 0 0 0 6-3c.5-5.2-.8-9.8-3.4-13.6zM8.5 15.4c-1.2 0-2.1-1.1-2.1-2.4s.9-2.4 2.1-2.4 2.2 1.1 2.1 2.4c0 1.3-.9 2.4-2.1 2.4zm7 0c-1.2 0-2.1-1.1-2.1-2.4s.9-2.4 2.1-2.4 2.2 1.1 2.1 2.4c0 1.3-.9 2.4-2.1 2.4z"/>', true),
    whatsapp: svg('<path d="M3 21l1.7-5A9 9 0 1 1 8 19.3z"/><path d="M9 9.5c0 3 2.5 5.5 5.5 5.5l1-1.5-2-1-1 .8a4 4 0 0 1-1.8-1.8l.8-1-1-2L9 9.5z"/>'),
    telegram: svg('<path d="m22 3-9.5 18-2.2-7.3L3 11.5z"/><path d="m10.3 13.7 4.2-4.2"/>'),
  };

  // ─── Lo que da cada plan (espejo de cf-worker/src/lib/agencyDirectory.js) ──
  // Ficha: diapositivas de «Conoce a la agencia» (y si llevan vídeo),
  // tarjetas de «Qué ofrece», tipos de creadores e hitos. PAGE_LIMITS.
  const PAGE_LIMITS = {
    titanium: { intro: 3, introVideo: true, offers: 6, types: 6, milestones: 3 },
    gold: { intro: 1, introVideo: true, offers: 6, types: 4, milestones: 3 },
    silver: { intro: 1, introVideo: false, offers: 3, types: 2, milestones: 3 },
  };
  const limits = planId => PAGE_LIMITS[planId] || PAGE_LIMITS.silver;
  // Hitos en la TARJETA de la lista (Titanium 3, Gold 1, Silver ninguno).
  const MILESTONES_BY_PLAN = { titanium: 3, gold: 1 };
  const cardMilestoneLimit = planId => MILESTONES_BY_PLAN[planId] || 0;
  // Vídeo en bucle en el banner de la ficha: Gold y Titanium.
  const BANNER_VIDEO_PLANS = ['titanium', 'gold'];
  const allowsBannerVideo = planId => BANNER_VIDEO_PLANS.includes(planId);

  // Topes de los textos (los mismos en el editor y en el Worker).
  const MAX_OFFERS = 6;
  const OFFER_TEXT_MAX = 28;
  const TYPE_TEXT_MAX = 24;
  const TAGLINE_MAX = 90;
  const INTRO_TITLE_MAX = 60;
  const INTRO_TEXT_MAX = 600;

  // ─── Gama de color de los iconos, por plan ─────────────────
  // Seis tonos parecidos al color del plan. Cada tarjeta de «Qué ofrece» y
  // cada tipo de creador guarda la POSICIÓN de su tono (color: 0-5), no el
  // color: si la agencia cambia de plan, sus iconos pasan a la gama nueva.
  // Sin color elegido, se reparten por orden.
  const PALETTES = {
    titanium: ['#c084fc', '#e879f9', '#a78bfa', '#f472b6', '#818cf8', '#d8b4fe'],
    gold: ['#fbbf24', '#f59e0b', '#fcd34d', '#fb923c', '#eab308', '#fde68a'],
    silver: ['#60a5fa', '#38bdf8', '#3b82f6', '#22d3ee', '#818cf8', '#93c5fd'],
  };
  const paletteOf = tier => PALETTES[tier] || PALETTES.silver;
  const colorIndex = (item, i, size) => (Number.isInteger(item && item.color) && item.color >= 0 && item.color < size ? item.color : i % size);
  const colorOf = (tier, item, i) => { const pal = paletteOf(tier); return pal[colorIndex(item, i, pal.length)]; };

  // ─── Secciones que la agencia ordena ───────────────────────
  const SECTION_IDS = ['about', 'offers', 'types', 'milestones'];
  function sectionOrder(raw) {
    const order = [];
    for (const id of Array.isArray(raw) ? raw : []) if (SECTION_IDS.includes(id) && !order.includes(id)) order.push(id);
    return [...order, ...SECTION_IDS.filter(id => !order.includes(id))];
  }
  /** Título de una sección (también lo usa el editor para sus bloques). */
  function sectionTitle(id, name) {
    if (id === 'about') return t('agencies_pg_about', 'Conoce {name}').replace('{name}', name || t('agencies_pg_about_fallback', 'la agencia'));
    if (id === 'offers') return t('agencies_pm_offers', 'Qué ofrece esta agencia');
    if (id === 'types') return t('agencies_pg_types', 'Ideal para creadores de');
    return t('agencies_pm_milestones', 'Hitos de la agencia');
  }

  // ─── Tipos de creadores: icono según el texto ──────────────
  // Para los que aún no tienen icono elegido (etiquetas de antes). Ids de
  // components/offer-icons.js.
  const TYPE_ICONS = [
    [/batall|battle|\bpk\b|versus/, 'bolt'],
    [/gam|jueg|videojueg|esport/, 'gamepad'],
    [/asmr|podcast|voz|voice|charla|chat|talk|tertulia/, 'microphone'],
    [/music|musica|cant|karaoke|\bdj\b|baile|dance/, 'music'],
    [/formaci|training|educa|curso|aprend/, 'graduation-cap'],
    [/\birl\b|vlog|exterior|viaj|travel/, 'video'],
    [/lifestyle|estilo de vida|moda|fashion|belleza|beauty/, 'heart'],
    [/cocina|cook|food|comida|receta/, 'egg'],
    [/fitness|deporte|sport|gym/, 'dumbbell'],
    [/arte|\bart\b|dibuj|draw|disen/, 'palette'],
    [/humor|comedia|comedy/, 'face-grin-wide'],
  ];
  const fold = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const typeIcon = text => (TYPE_ICONS.find(([re]) => re.test(fold(text))) || [0, 'star'])[1];

  // ─── Qué ofrece esta agencia ───────────────────────────────
  // La agencia escribe sus tarjetas (publicOffers: icono + texto + color,
  // editor en «Editar vista pública» › Ficha completa); si nunca las ha
  // editado, salen las de su plan (offers). Iconos de
  // components/offer-icons.js (los mismos en los dos casos).
  const OFFERS = {
    events: ['star', 'agencies_pm_offer_events', 'Eventos exclusivos'],
    missions: ['trophy', 'agencies_pm_offer_missions', 'Misiones y recompensas'],
    training: ['graduation-cap', 'agencies_pm_offer_training', 'Formación y recursos'],
    support: ['headset', 'agencies_pm_offer_support', 'Soporte personalizado'],
    growth: ['chart-simple', 'agencies_pm_offer_growth', 'Oportunidades de crecimiento'],
    community: ['heart', 'agencies_pm_offer_community', 'Comunidad activa'],
  };
  const offerIcon = id => (window.AgenciasOfferIcons ? window.AgenciasOfferIcons.svg(id) : '');
  /** Las tarjetas del plan (claves de offersFromPlan) como las propias: [{ icon, text }]. */
  const planOfferCards = keys => (keys || []).filter(k => OFFERS[k]).map(k => ({ icon: OFFERS[k][0], text: t(OFFERS[k][1], OFFERS[k][2]) }));

  // ─── Contacto: redes (iconos) vs. el resto ─────────────────
  const SOCIAL_HOSTS = [[/youtube\.com|youtu\.be/, 'youtube'], [/(^|\.)x\.com|twitter\.com/, 'x'], [/tiktok\.com/, 'tiktok'], [/instagram\.com/, 'instagram'], [/discord\.(gg|com)/, 'discord']];
  function socialKind(c) {
    if (['tiktok', 'instagram', 'discord'].includes(c.type)) return c.type;
    let host = '';
    try { host = new URL(c.href).hostname; } catch (_) { return null; }
    return (SOCIAL_HOSTS.find(([re]) => re.test(host)) || [0, null])[1];
  }
  const CONTACT_ICON = { email: 'mail', website: 'globe', phone: 'phone', whatsapp: 'whatsapp', telegram: 'telegram' };
  const SOCIALS_IN_HERO = 5;
  // Un correo (también escrito con otro tipo, p. ej. «Otro»). En la ficha
  // pública no sale ninguno: la abre cualquiera y el correo de contacto suele
  // ser el del dueño de la agencia; sus creadores lo ven en «Contactar» de su
  // vista. Espejo del Worker (agencyDirectory.js › publicContacts); aquí
  // también, por si la ficha llega de un Worker anterior.
  const EMAIL_VALUE = /^(mailto:)?[^\s@]+@[^\s@]+\.[^\s@]+$/i;
  const isEmailContact = c => !!c && (c.type === 'email' || EMAIL_VALUE.test(String(c.value || '').trim()));

  /** Contactos normalizados, cada uno con su icono (kind = red social o '' si no lo es). */
  function contactsOf(p) {
    return S().agencyContactMethods({ contactMethods: ((p && p.contacts) || []).filter(c => !isEmailContact(c)) }).map(c => {
      const kind = (c.href && socialKind(c)) || '';
      return { ...c, kind, icon: I[kind || CONTACT_ICON[c.type] || 'link'] };
    });
  }

  // ─── Cabecera de cada sección ──────────────────────────────
  function section(id, title, subtitle, body, cls = '') {
    return `<section class="agx-pg-sec${cls ? ' ' + cls : ''}" data-sec="${id}">
      <header class="agx-pg-sec-head"><h3>${title}</h3>${subtitle ? `<p>${subtitle}</p>` : ''}</header>
      ${body}
    </section>`;
  }

  // ─── Conoce a la agencia ───────────────────────────────────
  // Diapositivas que se ven: las de la agencia (según su plan) o, sin
  // ninguna, una con su descripción. La primera sin texto usa la descripción.
  function introSlides(a, p) {
    const lim = limits(a.tier);
    const desc = (p && p.description) || a.description || '';
    const slides = (p && Array.isArray(p.intro) ? p.intro : []).slice(0, lim.intro).map(s => {
      const videoUrl = lim.introVideo ? (s.videoUrl || '') : '';
      return { title: s.title || '', text: s.text || '', videoUrl, vertical: !!videoUrl && s.vertical === true };
    });
    if (!slides.length) return desc ? [{ title: '', text: desc, videoUrl: '', vertical: false }] : [];
    if (!slides[0].text) slides[0].text = desc;
    return slides.filter(s => s.text || s.videoUrl);
  }

  // o.slide: diapositiva a la vista (la vista previa enseña la que se edita).
  function aboutHtml(a, p, o = {}) {
    const slides = introSlides(a, p);
    if (!slides.length) return '';
    const active = Math.min(Math.max(0, Math.trunc(Number(o.slide)) || 0), slides.length - 1);
    const many = slides.length > 1;
    const slide = (s, i) => `
      <article class="agx-pg-slide${s.videoUrl ? ' has-video' : ''}${s.vertical ? ' is-vertical' : ''}${i === active ? ' is-on' : ''}"${many ? ` role="group" aria-roledescription="slide" aria-label="${i + 1} / ${slides.length}"` : ''}>
        ${s.videoUrl ? `<div class="agx-pg-video">
          <video src="${img(s.videoUrl)}#t=0.1" preload="metadata" playsinline></video>
          <button type="button" class="agx-pg-play" data-pg="play" aria-label="${esc(t('agencies_pg_play', 'Reproducir vídeo'))}">${I.play}</button>
        </div>` : ''}
        <div class="agx-pg-slide-text">
          ${s.title ? `<h4>${esc(s.title)}</h4>` : ''}
          ${s.text ? `<p>${esc(s.text)}</p>` : ''}
        </div>
      </article>`;
    const nav = !many ? '' : `<div class="agx-pg-slide-nav">
        <button type="button" data-pg="slide" data-to="prev" aria-label="${esc(t('agencies_pg_slide_prev', 'Anterior'))}">${I.prev}</button>
        <div class="agx-pg-dots">${slides.map((_, i) => `<button type="button" data-pg="slide" data-to="${i}"${i === active ? ' aria-current="true"' : ''} aria-label="${i + 1} / ${slides.length}"></button>`).join('')}</div>
        <button type="button" data-pg="slide" data-to="next" aria-label="${esc(t('agencies_pg_slide_next', 'Siguiente'))}">${I.next}</button>
      </div>`;
    return section('about', esc(sectionTitle('about', a.name)),
      esc(t('agencies_pg_about_sub', 'Descubre quiénes somos, qué hacemos y por qué los creadores confían en nosotros.')),
      `<div class="agx-pg-slides">${slides.map(slide).join('')}</div>${nav}`, 'agx-pg-about');
  }

  // ─── Qué ofrece / Ideal para creadores de ──────────────────
  // p: el perfil. Las de la agencia (aunque las haya vaciado: sin sección) o,
  // si nunca las editó (o el Worker aún no manda publicOffers), las del plan.
  function offersHtml(a, p) {
    const own = Array.isArray(p.publicOffers);
    const list = (own ? p.publicOffers : planOfferCards(p.offers)).slice(0, limits(a.tier).offers);
    if (!list.length) return '';
    // Hasta tres, casillas anchas (icono a la izquierda); con más, una fila
    // de casillas con el icono encima.
    return section('offers', esc(sectionTitle('offers')), esc(t('agencies_pm_offers_sub', 'Beneficios para creadores')),
      `<div class="agx-pg-offers${list.length <= 3 ? ' is-wide' : ''}" style="--n:${list.length}">${list.map((o, i) => `
        <div class="agx-pg-offer" style="--c:${colorOf(a.tier, o, i)}"><span class="agx-pg-ic">${offerIcon(o.icon)}</span><span>${esc(o.text)}</span></div>`).join('')}</div>`);
  }

  // Los tipos de la agencia o, con un Worker anterior (sin `types`), las
  // etiquetas de la tarjeta del directorio.
  function typesOf(a, p) {
    const list = p && Array.isArray(p.types) ? p.types : (a.tags || []).map(text => ({ icon: '', text }));
    return list.slice(0, limits(a.tier).types);
  }
  function typesHtml(a, p) {
    const list = typesOf(a, p);
    if (!list.length) return '';
    return section('types', esc(sectionTitle('types')), esc(t('agencies_pg_types_sub', 'Especializados en las siguientes categorías')),
      `<div class="agx-pg-types" style="--n:${list.length}">${list.map((o, i) => `
        <div class="agx-pg-type" style="--c:${colorOf(a.tier, o, i)}"><span class="agx-pg-ic">${offerIcon(o.icon || typeIcon(o.text))}</span><span>${esc(o.text)}</span></div>`).join('')}</div>`);
  }

  // ─── Hitos ─────────────────────────────────────────────────
  // Los de la ficha (hasta 3, con su imagen) o, mientras llega o con un
  // Worker anterior, los de la tarjeta del directorio.
  function milestonesOf(a, p) {
    const list = p && Array.isArray(p.milestones) ? p.milestones : (Array.isArray(a.milestones) ? a.milestones : []);
    return list.slice(0, limits(a.tier).milestones);
  }
  function milestonesHtml(a, p) {
    const list = milestonesOf(a, p);
    if (!list.length) return '';
    // Con imagen, la foto de fondo y el texto encima; sin ella, su icono.
    // Uno solo: una fila ancha (imagen o icono a la izquierda). El título no
    // es obligatorio: un hito puede ser solo su imagen (is-bare: la foto,
    // sin el oscurecido que deja leer el texto).
    return section('milestones', esc(sectionTitle('milestones')), esc(t('agencies_pg_milestones_sub', 'Reconocimientos que avalan nuestro trabajo.')),
      `<div class="agx-pg-ms-grid${list.length === 1 ? ' is-single' : ''}" style="--n:${list.length}">${list.map(m => {
        const bare = !m.title && !m.subtitle;
        return `
        <article class="agx-pg-ms${m.imageUrl ? ' has-img' : ''}${bare ? ' is-bare' : ''}">
          ${m.imageUrl ? `<img src="${img(m.imageUrl)}" alt="" loading="lazy">` : `<span class="agx-pg-ic">${Card().milestoneIcon(m.icon)}</span>`}
          ${bare ? '' : `<div class="agx-pg-ms-t">${m.title ? `<strong>${esc(m.title)}</strong>` : ''}${m.subtitle ? `<small>${esc(m.subtitle)}</small>` : ''}</div>`}
        </article>`;
      }).join('')}</div>`);
  }

  // a = ficha del directorio · p = perfil (null mientras llega: esqueleto).
  function sectionsHtml(a, p, o = {}) {
    if (!p) return '<div class="agx-pg-skeleton"></div><div class="agx-pg-skeleton"></div><div class="agx-pg-skeleton"></div>';
    const html = { about: aboutHtml(a, p, o), offers: offersHtml(a, p), types: typesHtml(a, p), milestones: milestonesHtml(a, p) };
    return sectionOrder(p.sectionOrder).map(id => html[id]).join('');
  }

  // ─── Tarjeta de presentación ───────────────────────────────
  // Banner de fondo: el vídeo en bucle y sin sonido de Gold y Titanium (la
  // imagen, si la hay, de póster), su imagen o, sin nada, el degradado del
  // plan. Con «reducir movimiento» del sistema, la imagen.
  const hasBannerVideo = a => !!a.bannerVideoUrl && allowsBannerVideo(a.tier);
  function bannerHtml(a) {
    const poster = a.bannerUrl ? img(a.bannerUrl) : '';
    const reduced = !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (hasBannerVideo(a) && !reduced) {
      return `<video src="${img(a.bannerVideoUrl)}"${poster ? ` poster="${poster}"` : ''} autoplay muted loop playsinline disablepictureinpicture preload="auto" aria-hidden="true"></video>`;
    }
    return poster ? `<img src="${poster}" alt="">` : '';
  }

  // Frase gancho; sin ella (agencias que aún no la han escrito), la
  // descripción, que la cabecera recorta a dos líneas.
  const taglineOf = (a, p) => (p && p.tagline) || a.tagline || (p && p.description) || a.description || '';

  const joinBtn = preview => `<button type="button" class="agx-pg-join" data-pg="join"${preview ? ' tabindex="-1" aria-hidden="true"' : ''}>${t('agencies_pm_join', 'Unirse a la agencia')}${I.arrow}</button>`;

  // «Contactar» (abre todas las formas de contacto) + las redes, con su icono.
  function heroContactHtml(p, preview) {
    const all = contactsOf(p);
    if (!all.length) return '';
    const off = preview ? ' tabindex="-1"' : '';
    return `<button type="button" class="agx-pg-ghost" data-pg="contact"${off}>${t('agencies_pg_contact', 'Contactar')}</button>
      ${all.filter(c => c.kind).slice(0, SOCIALS_IN_HERO).map(c => `<a class="agx-pg-social" href="${esc(c.href)}" target="_blank" rel="noopener" title="${esc(c.display || c.value)}" aria-label="${esc(c.kind)}"${off}>${c.icon}</a>`).join('')}`;
  }

  // o.actions: HTML en lugar de «Unirse a la agencia» (la consola pone ahí
  // «Editar vista pública» y «Ver cómo te ven»: Agencia › Resumen).
  // o.emptyContact: lo que va en el sitio de «Contactar» si la agencia no
  // tiene ninguna forma de contacto (en el Explorador, nada).
  function heroHtml(a, p, preview, o = {}) {
    const tagline = taglineOf(a, p);
    return `<header class="agx-pg-hero${a.bannerUrl || hasBannerVideo(a) ? ' has-media' : ''}">
      <div class="agx-pg-hero-bg">${bannerHtml(a)}</div>
      <div class="agx-pg-hero-main">
        ${Card().logoHtml(a)}
        <div class="agx-pg-id">
          <h2 class="agx-pg-name"><span>${esc(a.name)}</span>${Card().verifiedHtml(a)}</h2>
          ${Card().locationHtml(a)}
          <p class="agx-pg-tagline" data-pg-slot="tagline"${tagline ? '' : ' hidden'}>${esc(tagline)}</p>
        </div>
        ${o.actions != null ? `<div class="agx-pg-hero-actions">${o.actions}</div>` : joinBtn(preview)}
      </div>
      <div class="agx-pg-hero-foot">
        <div class="agx-pg-stats">${Card().statsHtml(a)}</div>
        <div class="agx-pg-hero-contact" data-pg-slot="contact">${p ? (heroContactHtml(p, preview) || o.emptyContact || '') : ''}</div>
      </div>
    </header>`;
  }

  function ctaHtml(a, p, preview) {
    const hasContact = !!(p && contactsOf(p).length);
    return `<section class="agx-pg-cta">
      <div>
        <h3>${esc(t('agencies_pg_cta_title', '¿Te interesa unirte a {name}?').replace('{name}', a.name))}</h3>
        <p>${esc(t('agencies_pg_cta_sub', 'Forma parte de una comunidad que impulsa tu talento.'))}</p>
      </div>
      <div class="agx-pg-cta-actions">
        ${joinBtn(preview)}
        <button type="button" class="agx-pg-ghost" data-pg="contact" data-pg-slot="cta-contact"${hasContact ? '' : ' hidden'}${preview ? ' tabindex="-1"' : ''}>${t('agencies_pg_contact_team', 'Contactar equipo')}</button>
      </div>
    </section>`;
  }

  function navHtml(a) {
    const back = t('agencies_pg_back', 'Volver al explorador de agencias');
    return `<nav class="agx-pg-nav" aria-label="${esc(t('agencies_pg_crumbs', 'Dónde estás'))}">
      <ol class="agx-pg-crumbs">
        <li><button type="button" data-pg="back">${esc(t('agencies_pg_crumb_agencies', 'Agencias'))}</button></li>
        <li><button type="button" data-pg="back">${esc(t('agencies_pg_crumb_explorer', 'Explorar agencias'))}</button></li>
        <li aria-current="page">${esc(a.name)}</li>
      </ol>
      <button type="button" class="agx-pg-back" data-pg="back">${I.back}<span>${esc(back)}</span></button>
    </nav>`;
  }

  // ─── Ficha en HTML ─────────────────────────────────────────
  // La pinta la página «Ver agencia» y, con datos locales (fromAgency), la
  // vista previa de «Editar vista pública» de la consola, para que nunca
  // mienta. a = ficha del directorio · p = perfil (GET /api/agency/profile)
  // o null mientras llega (esqueleto) · o.preview: sin migas ni «Volver» y
  // con los botones de adorno · o.slide: diapositiva de «Conoce» a la vista.
  function sheetHtml(a, p, o = {}) {
    const preview = !!o.preview;
    return `
      <div class="agx-pg is-tier-${Card().tierOf(a)}${preview ? ' is-preview' : ''}">
        ${preview ? '' : navHtml(a)}
        ${heroHtml(a, p, preview)}
        <div class="agx-pg-sections"${p ? '' : ' aria-busy="true"'}>${sectionsHtml(a, p, o)}</div>
        ${ctaHtml(a, p, preview)}
      </div>`;
  }

  // ─── Comportamiento (página y vista previa) ────────────────
  // Carrusel de «Conoce» y reproducción de sus vídeos; back/join/contact se
  // delegan en quien monta la ficha. Se puede llamar en cada repintado: el
  // contenedor solo se engancha una vez.
  function pauseVideos(scope, except) {
    scope.querySelectorAll('.agx-pg-video video').forEach(v => { if (v !== except) { try { v.pause(); } catch (_) { /* sin cargar */ } } });
  }

  function play(btn, root) {
    const box = btn.closest('.agx-pg-video');
    const video = box && box.querySelector('video');
    if (!video) return;
    pauseVideos(root, video);
    box.classList.add('is-playing');
    video.controls = true;
    video.play().catch(() => { /* el usuario puede darle al play de los controles */ });
  }

  function goSlide(btn, root, handlers) {
    const about = btn.closest('.agx-pg-about');
    const slides = about ? [...about.querySelectorAll('.agx-pg-slide')] : [];
    if (slides.length < 2) return;
    const current = Math.max(0, slides.findIndex(s => s.classList.contains('is-on')));
    const to = btn.dataset.to;
    const next = to === 'prev' ? (current + slides.length - 1) % slides.length : to === 'next' ? (current + 1) % slides.length : Number(to);
    if (!(next >= 0 && next < slides.length) || next === current) return;
    pauseVideos(about);
    slides.forEach((s, i) => s.classList.toggle('is-on', i === next));
    about.querySelectorAll('.agx-pg-dots button').forEach((d, i) => { if (i === next) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    handlers.onSlide?.(next);
  }

  // La vista previa de la consola se repinta cambiando solo lo que cambia
  // (AgenciasShared.morphHtml): un vídeo de «Conoce» sigue siendo el mismo y
  // no vuelve a avisar de sus medidas ni de que se está reproduciendo, pero
  // el repintado le quita las clases que se le pusieron entonces. Se las
  // devuelve.
  function restoreVideos(root) {
    root.querySelectorAll('.agx-pg-video video').forEach(v => {
      if (v.videoWidth && v.videoHeight > v.videoWidth) v.closest('.agx-pg-slide')?.classList.add('is-vertical');
      if (!v.paused && !v.ended) {
        v.controls = true;
        v.closest('.agx-pg-video')?.classList.add('is-playing');
      }
    });
  }

  /** handlers: { onBack, onJoin(btn), onContact, onSlide(i) }. */
  function wire(root, handlers = {}) {
    root.__agxPg = handlers;
    restoreVideos(root);
    if (root.__agxPgWired) return;
    root.__agxPgWired = true;
    root.addEventListener('click', ev => {
      const el = ev.target.closest('[data-pg]');
      if (!el || !root.contains(el)) return;
      const h = root.__agxPg || {};
      const act = el.dataset.pg;
      if (act === 'play') play(el, root);
      else if (act === 'slide') goSlide(el, root, h);
      else if (act === 'back') h.onBack?.();
      else if (act === 'join') h.onJoin?.(el);
      else if (act === 'contact') h.onContact?.(el);
    });
    // Un vídeo vertical que no venía marcado como tal (lo mide el editor al
    // subirlo): se recoloca en cuanto se conocen sus medidas.
    root.addEventListener('loadedmetadata', ev => {
      const v = ev.target;
      const slide = v.closest?.('.agx-pg-slide');
      if (slide && v.videoWidth && v.videoHeight > v.videoWidth) slide.classList.add('is-vertical');
    }, true);
  }

  // ─── Datos locales → ficha pública (espejo del Worker) ─────
  // Lo mismo que sirven GET /api/agency/directory y /api/agency/profile
  // (cf-worker/src/lib/agencyDirectory.js: toDirectoryEntry, toProfileExtras,
  // sanitize*, offersFromPlan, publicContacts) calculado desde un documento
  // agencies/{id} en memoria: la consola lo usa con lo que hay en el
  // formulario de «Editar vista pública». Si cambia allí, cambia aquí.
  const MILESTONE_ICONS = ['trophy', 'users', 'star', 'medal', 'fire', 'rocket'];
  const ICON_ID_RE = /^[a-z0-9-]{1,40}$/;
  const isIconId = v => typeof v === 'string' && ICON_ID_RE.test(v);
  const clip = (v, max) => (typeof v === 'string' ? v.trim().slice(0, max) : '');
  const httpUrl = v => { const s = clip(v, 2048); return /^https?:\/\//i.test(s) ? s : ''; };
  const paletteColor = v => (Number.isInteger(v) && v >= 0 && v < PALETTES.silver.length ? { color: v } : {});
  function toMillis(v) {
    if (!v) return 0;
    if (typeof v.toMillis === 'function') return v.toMillis();
    if (typeof v === 'number') return v;
    if (v.seconds) return v.seconds * 1000;
    const ms = Date.parse(v);
    return Number.isFinite(ms) ? ms : 0;
  }

  /** «Qué ofrece esta agencia»: ventajas que su plan efectivo le da a sus creadores. */
  function offersFromPlan(plan) {
    const f = (plan && plan.features) || {};
    const out = [];
    if (f.agencyEvents) out.push('events');
    if (f.missionsAuto || f.missionsCustom) out.push('missions');
    if (f.library) out.push('training');
    if (f.writtenSupport || f.prioritySupport) out.push('support');
    if (f.fullAnalytics) out.push('growth');
    if (f.creatorCommunity) out.push('community');
    return out;
  }

  /** «Qué ofrece» propio (agencies/{id}.publicOffers) saneado, o null si nunca lo editó. */
  function sanitizeOffers(raw, max = MAX_OFFERS) {
    if (!Array.isArray(raw)) return null;
    return raw
      .map(o => ({ icon: isIconId(o && o.icon) ? o.icon : 'star', text: clip(o && o.text, OFFER_TEXT_MAX), ...paletteColor(o && o.color) }))
      .filter(o => o.text)
      .slice(0, Math.min(max, MAX_OFFERS));
  }

  /** «Ideal para creadores de»: publicTypes o, si no las tiene, sus etiquetas (publicTags). */
  function sanitizeTypes(raw, tags, max) {
    const list = Array.isArray(raw) ? raw : (Array.isArray(tags) ? tags.map(text => ({ text })) : []);
    return list
      .map(o => ({ icon: isIconId(o && o.icon) ? o.icon : '', text: clip(o && o.text, TYPE_TEXT_MAX), ...paletteColor(o && o.color) }))
      .filter(o => o.text)
      .slice(0, max);
  }

  /** «Conoce a la agencia»: diapositivas según el plan (lim = limits(plan)). */
  function sanitizeIntro(raw, lim) {
    return (Array.isArray(raw) ? raw : [])
      .map(s => {
        const videoUrl = lim.introVideo ? httpUrl(s && s.videoUrl) : '';
        return { title: clip(s && s.title, INTRO_TITLE_MAX), text: clip(s && s.text, INTRO_TEXT_MAX), videoUrl, vertical: !!videoUrl && !!s && s.vertical === true };
      })
      .filter(s => s.title || s.text || s.videoUrl)
      .slice(0, lim.intro);
  }

  function sanitizeMilestones(raw, max, images) {
    return (Array.isArray(raw) ? raw : [])
      .map(m => {
        const out = { icon: MILESTONE_ICONS.includes(m && m.icon) ? m.icon : 'trophy', title: clip(m && m.title, 24), subtitle: clip(m && m.subtitle, 50) };
        const imageUrl = images ? httpUrl(m && m.imageUrl) : '';
        if (imageUrl) out.imageUrl = imageUrl;
        return out;
      })
      // Vale con título, con detalle o con imagen (espejo del Worker).
      .filter(m => m.title || m.subtitle || m.imageUrl)
      .slice(0, max);
  }

  /**
   * doc: agencies/{id} (con id). o.creators: creadores del roster vigente si
   * se conocen (el Worker los cuenta así); si no, stats.totalMembers.
   * Devuelve el perfil ({ agency, description, tagline, milestones, offers,
   * publicOffers, types, intro, sectionOrder, contacts, backstageLink }) y
   * visibility: 'listed' | 'plan' (su plan no incluye el directorio) |
   * 'validation' (TikControl aún no la ha validado).
   */
  function fromAgency(doc, o = {}) {
    const d = doc || {};
    const plan = S().agencyPlan(d);
    const lim = limits(plan.id);
    const year = Math.trunc(Number(d.foundedYear));
    const tagline = clip(d.publicTagline, TAGLINE_MAX);
    const agency = {
      id: d.id || '',
      name: clip(d.name, 80),
      logoUrl: httpUrl(d.logoUrl),
      bannerUrl: httpUrl(d.bannerUrl),
      cardImageUrl: httpUrl(d.cardImageUrl),
      bannerVideoUrl: allowsBannerVideo(plan.id) ? httpUrl(d.bannerVideoUrl) : '',
      description: clip(d.publicMessage || d.description, 420),
      tagline,
      region: clip(d.region, 80),
      verified: d.verified === true,
      tier: plan.id,
      highlight: plan.highlightLevel,
      creators: Number.isFinite(o.creators) ? o.creators : Math.max(0, Math.trunc(Number(d.stats && d.stats.totalMembers) || 0)),
      foundedYear: year >= 1990 && year <= 2100 ? year : null,
      joinedAt: toMillis(d.createdAt),
      tags: (Array.isArray(d.publicTags) ? d.publicTags : []).map(x => clip(x, 30)).filter(Boolean).slice(0, 7),
      milestones: sanitizeMilestones(d.publicMilestones, cardMilestoneLimit(plan.id), false),
    };
    const features = plan.features || {};
    return {
      agency,
      description: clip(d.publicMessage || d.description, 2000),
      tagline,
      milestones: sanitizeMilestones(d.publicMilestones, lim.milestones, true),
      offers: offersFromPlan(plan),
      publicOffers: sanitizeOffers(d.publicOffers, lim.offers),
      types: sanitizeTypes(d.publicTypes, d.publicTags, lim.types),
      intro: sanitizeIntro(d.publicIntro, lim),
      sectionOrder: sectionOrder(d.publicSectionOrder),
      contacts: S().agencyContactMethodsRaw(d).filter(c => !isEmailContact(c)).slice(0, 12),
      backstageLink: features.backstageLink ? httpUrl(d.backstageLink) : '',
      visibility: !features.directoryListing ? 'plan' : (d.validated === true ? 'listed' : 'validation'),
    };
  }

  // ─── Página ────────────────────────────────────────────────
  // Se monta junto al Explorador (.agx), que se esconde tal cual está —mapa,
  // búsqueda y página de la lista— y vuelve igual, con su scroll, al cerrar.
  // También sobre la guía de primera visita (sus destacadas abren la ficha).
  // Entrada: la lista se desvanece, la ficha sube (cabecera, logo, nombre y
  // cifras escalonados; agx-pg-host.is-entering) y, al llegar el perfil,
  // sus secciones entran una tras otra (agx-pg-sections.is-in). Salida: la
  // ficha se desvanece y vuelve la lista (agx.is-returning). Con «reducir
  // movimiento» del sistema, sin animación.
  const MOTION = { listOutMs: 130, pageOutMs: 190, enterMs: 1300, sectionsMs: 1100, returnMs: 450 };
  const animated = el => !!el.animate && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  let page = null;   // { host, list, scroller, top, onKey, closing, done }
  let openSeq = 0;   // sube en cada apertura: una que termina tarde no monta nada

  function scrollerOf(el) {
    for (let n = el && el.parentElement; n; n = n.parentElement) {
      const oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    }
    return document.scrollingElement;
  }

  /** o.instant: sin animación de salida (la vista se va a repintar o se abre otra ficha). */
  function close(o = {}) {
    openSeq++;
    if (!page) return;
    const cur = page;
    const { host, list, scroller, top, onKey } = cur;
    const move = !o.instant && animated(host);
    const finish = () => {
      if (cur.done) return;
      cur.done = true;
      if (page === cur) page = null;
      document.removeEventListener('keydown', onKey);
      pauseVideos(host);
      host.remove();
      if (!list.isConnected) return;
      list.hidden = false;
      if (scroller) scroller.scrollTop = top;
      if (!move) return;
      list.classList.add('is-returning');
      setTimeout(() => list.classList.remove('is-returning'), MOTION.returnMs);
    };
    if (!move || !host.isConnected) { finish(); return; }
    if (cur.closing) return;
    cur.closing = true;
    pauseVideos(host);
    host.classList.add('is-leaving');
    host.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(12px)' }], { duration: MOTION.pageOutMs, easing: 'ease-in', fill: 'forwards' })
      .finished.then(finish, finish);
    // Seguro: si la animación no avanza (ventana minimizada), se cierra igual.
    setTimeout(finish, MOTION.pageOutMs + 300);
  }

  // Lo que no trae la tarjeta del directorio, cuando la ficha no llega.
  const offlineProfile = a => ({ description: a.description, tagline: a.tagline, milestones: a.milestones, publicOffers: [], offers: [], contacts: [], backstageLink: '' });

  /** a = ficha del directorio. Pinta ya la cabecera y completa el resto al llegar el perfil. */
  async function open(a) {
    close({ instant: true });
    S().closeModal();
    const list = document.querySelector('#view-agencias .agx');
    if (!list) return;
    const seq = ++openSeq;
    // El perfil se pide ya: llega mientras la lista se va.
    const profile = Dir().loadProfile(a.id);
    profile.catch(() => { /* se trata abajo, al pintar */ });

    const scroller = scrollerOf(list);
    const top = scroller ? scroller.scrollTop : 0;
    const move = animated(list);
    let fade = null;
    if (move) {
      fade = list.animate([{ opacity: 1 }, { opacity: 0 }], { duration: MOTION.listOutMs, easing: 'ease-out', fill: 'forwards' });
      // (Con seguro: si la animación no avanza —ventana minimizada—, se abre igual.)
      await Promise.race([
        fade.finished.catch(() => { /* cancelada: se monta igual */ }),
        new Promise(resolve => setTimeout(resolve, MOTION.listOutMs + 150)),
      ]);
      // Mientras tanto se abrió otra, se cerró o se repintó el Explorador.
      if (seq !== openSeq || !list.isConnected) { fade.cancel(); return; }
    }

    const host = document.createElement('div');
    host.className = 'ag-container agx-pg-host' + (move ? ' is-entering' : '');
    host.innerHTML = sheetHtml(a, null);
    list.hidden = true;
    if (fade) fade.cancel();
    list.after(host);
    if (scroller) scroller.scrollTop = 0;
    if (move) setTimeout(() => host.classList.remove('is-entering'), MOTION.enterMs);

    // Escape vuelve al Explorador (si no hay un modal encima).
    const onKey = ev => { if (ev.key === 'Escape' && !document.getElementById('ag-modal-overlay') && !document.fullscreenElement) close(); };
    document.addEventListener('keydown', onKey);
    page = { host, list, scroller, top, onKey, closing: false, done: false };

    let loaded = null;
    const fill = (p, failed) => {
      if (!host.isConnected) return;
      loaded = p;
      const sections = host.querySelector('.agx-pg-sections');
      sections.innerHTML = sectionsHtml(a, p) + (failed ? `<p class="agx-pg-error">${esc(t('agencies_pm_load_error', 'No se pudo cargar el resto de la ficha.'))}</p>` : '');
      sections.removeAttribute('aria-busy');
      // Las secciones entran una tras otra.
      if (move) {
        sections.classList.add('is-in');
        setTimeout(() => sections.classList.remove('is-in'), MOTION.sectionsMs);
      }
      host.querySelector('[data-pg-slot="contact"]').innerHTML = heroContactHtml(p, false);
      host.querySelector('[data-pg-slot="cta-contact"]').hidden = !contactsOf(p).length;
      // La ficha trae la frase gancho (o la descripción entera).
      const tagline = host.querySelector('[data-pg-slot="tagline"]');
      tagline.textContent = taglineOf(a, p);
      tagline.hidden = !tagline.textContent;
    };
    profile.then(p => fill(p, false), e => {
      console.warn('[Explorer] ficha no disponible:', e.message);
      fill(offlineProfile(a), true);
    });

    wire(host, {
      onBack: () => close(),
      onJoin: async btn => {
        btn.disabled = true;
        const p = await profile.catch(() => null);
        btn.disabled = false;
        if (p?.backstageLink) window.open(p.backstageLink, '_blank');
        else showJoinSteps(a);
      },
      onContact: () => { if (loaded) showContact(a, loaded); },
    });
  }

  // Todas las formas de contacto de la agencia, en su orden.
  function showContact(a, p) {
    const all = contactsOf(p);
    if (!all.length) return;
    const row = c => {
      const text = `<span>${esc(c.label || c.display || c.value)}</span>`;
      return c.href
        ? `<a class="agx-pg-contact" href="${esc(c.href)}" target="_blank" rel="noopener">${c.icon}${text}${I.arrow}</a>`
        : `<span class="agx-pg-contact">${c.icon}${text}</span>`;
    };
    S().showModal(
      esc(t('agencies_pg_contact_title', 'Contactar con {name}').replace('{name}', a.name)),
      `<div class="agx-pg-contacts">${all.map(row).join('')}</div>`,
      `<button class="btn btn-primary" onclick="window.AgenciasShared.closeModal()">${t('agencies_close', 'Cerrar')}</button>`
    );
  }

  // Sin enlace de reclutamiento: cómo llega un creador a la agencia.
  function showJoinSteps(a) {
    const shared = S();
    const step = (n, title, desc) => `
      <div class="ag-join-step">
        <span class="ag-join-step-num">${n}</span>
        <div><strong>${title}</strong><p>${desc}</p></div>
      </div>`;
    const tiktok = shared.state.tiktokUsername;

    shared.showModal(
      `${t('agencies_join_to', 'Unirme a')} ${esc(a.name)}`,
      `<div class="ag-join-flow">
        ${step(1, t('agencies_join_step1_title', 'Primero debes ser aceptado por la agencia en TikTok'), t('agencies_join_step1_desc', 'Contacta con la agencia y solicita que te acepten como creador en su programa de TikTok.'))}
        ${step(2, t('agencies_join_step2_title', 'La agencia te añade a su whitelist en TikControl'), t('agencies_join_step2_desc', 'Una vez aceptado, el manager de la agencia añadirá tu email o @ de TikTok a la whitelist.'))}
        ${step(3, t('agencies_join_step3_title', 'Recibirás invitación aquí para entrar como miembro'), t('agencies_join_step3_desc', 'Vuelve a esta pestaña y podrás unirte automáticamente con acceso a todos los beneficios.'))}
        <div class="ag-join-info">
          <h5>${t('agencies_your_info', 'Tu información actual')}</h5>
          <div class="ag-join-info-row"><span>Email:</span><code>${esc(shared.state.currentUser?.email || '-')}</code></div>
          <div class="ag-join-info-row"><span>TikTok:</span>${tiktok ? `<code>@${esc(tiktok)}</code>` : `<em>${t('agencies_not_linked', 'No vinculado')}</em>`}</div>
        </div>
      </div>`,
      `<button class="btn btn-primary" onclick="window.AgenciasShared.closeModal()">${t('agencies_close', 'Cerrar')}</button>`,
      { size: 'lg' }
    );
  }

  return {
    open, close, sheetHtml, wire, fromAgency, offersFromPlan,
    // La tarjeta de presentación sola y la lista de contactos (cabecera de
    // Agencia › Resumen en la consola).
    heroHtml, showContact, contactsOf,
    // Para el editor de la ficha (owner-console/public-view.js).
    limits, allowsBannerVideo, planOfferCards, paletteOf, colorIndex, typeIcon, sectionOrder, sectionTitle, SECTION_IDS,
    MAX_OFFERS, OFFER_TEXT_MAX, TYPE_TEXT_MAX, TAGLINE_MAX, INTRO_TITLE_MAX, INTRO_TEXT_MAX,
  };
})();
